export default __webpack_public_path__ + "static/media/support-iot-studio.0c16b3a2.yaml";